import { FormattedMessage, useIntl } from 'react-intl'
import { clsx } from 'clsx'
import { observer } from 'mobx-react'

import { GLOBAL_ROUTE_PATHS } from 'Router/Router.constants'

import { useIsServiceApp } from 'Hooks'

import { isActiveLanguage } from 'Utilities'

import { SupportedLanguagesEnum } from 'Constants/locale'

import ECOVADIS_LOGO_SRC from 'Assets/images/logos/ecovadis_logo.svg'

import { LinkButton } from '../_theme/LinkButton/LinkButton'
import { FooterProps } from './Footer.types'

export const Footer = observer((props: FooterProps) => {
  const { className, variant = 'dark', onLogin } = props

  const isGermanLanguageActive = isActiveLanguage(SupportedLanguagesEnum.DE)
  const intl = useIntl()
  const isServiceApp = useIsServiceApp()

  const isLight = variant === 'light'
  const classNames = clsx(
    'Footer',
    isLight && 'Footer-light',
    onLogin && 'Footer-login',
    className,
  )

  if (isServiceApp) {
    return null
  }

  return (
    <div aria-label="Footer links" className={classNames} role="navigation">
      <div>
        <span className="h6">{new Date().getFullYear()} © Everphone</span>
      </div>

      <div className="Footer-links">
        <LinkButton
          size="small"
          title={intl.formatMessage({ id: 'DataPrivacy_footer_title' })}
          to={GLOBAL_ROUTE_PATHS.public.dataPrivacy}
          variant={isLight ? 'light' : 'dark'}
        >
          <FormattedMessage id="DataPrivacy_footer_title" />
        </LinkButton>

        <LinkButton
          asExternalLink
          rel="noopener noreferrer"
          size="small"
          target="_blank"
          title={`${intl.formatMessage({
            id: 'Imprint',
          })} - opens in a new tab`}
          to={
            isGermanLanguageActive
              ? 'https://www.everphone.com/de/impressum/'
              : 'https://www.everphone.com/imprint/'
          }
          variant={isLight ? 'light' : 'dark'}
        >
          <FormattedMessage id="Imprint" />
        </LinkButton>

        <LinkButton
          asExternalLink
          rel="noopener noreferrer"
          size="small"
          target="_blank"
          title={`${intl.formatMessage({
            id: 'Security',
          })} - opens in a new tab`}
          to="https://security.everphone.app/"
          variant={isLight ? 'light' : 'dark'}
        >
          <FormattedMessage id="Security" />
        </LinkButton>

        <img
          alt="ecovadis 2023 Silver Sustainability Rating"
          className="Footer-image"
          height={40}
          src={ECOVADIS_LOGO_SRC}
        />
      </div>
    </div>
  )
})
